import BookShow from "components/shared/book/show";
import { FilesField } from "components/shared/form";
import { dateTimeToView } from "helpers/date";
import { serializeReq, validateForm } from "helpers/form";
import { viewContainer } from "helpers/redux";
import { requiredField } from "helpers/validators";
import React from "react";
import { resourceEnum } from "../constants";
import { config, initialState } from "../formConfig";

class ShowExpense extends BookShow {
    get dropdActions() {
        const { canEditBooks } = this.props;

        const actions = [];

        if (canEditBooks) {
            actions.push({ text: "Удалить", action: this.actionClose });
        }

        return actions;
    }

    getItem = ({ source, match }) => {
        const defParams = { isLoading: false, isValid: true, shouldUpdate: false };
        source.getItem(match.params).then((data) => {
            const resource = data.carId ? resourceEnum.CAR : data.driverId ? resourceEnum.DRIVER : resourceEnum.TRAILER;

            const newData = { resource, fileIds: data.files, ...data };

            this.setState({ data: newData, initial: newData, ...defParams });
        });
    };

    isValidForm = (state) => {
        const copyConfig = { ...this.props.config };

        if (state.resource === resourceEnum.CAR) {
            copyConfig.carId = { ...copyConfig.carId, validators: [requiredField], required: true };
        } else if (state.resource === resourceEnum.TRAILER) {
            copyConfig.trailerId = { ...copyConfig.trailerId, validators: [requiredField], required: true };
        } else if (state.resource === resourceEnum.DRIVER) {
            copyConfig.driverId = { ...copyConfig.driverId, validators: [requiredField], required: true };
        }

        if (state.periodType) {
            copyConfig.period = { ...copyConfig.period, validators: [requiredField], required: true };
        }

        return validateForm(copyConfig, serializeReq(state));
    };

    apply = () => {
        const { source, match, mergeParams } = this.props;
        const { isLoading, shouldUpdate, data } = this.state;

        if (!isLoading && shouldUpdate) {
            if (this.isValidForm(data)) {
                this.setState({ isLoading: true, isValid: true });

                const resourceByName = {
                    [resourceEnum.CAR]: { carId: data.carId },
                    [resourceEnum.DRIVER]: { driverId: data.driverId },
                    [resourceEnum.TRAILER]: { trailerId: data.trailerId },
                };

                const serialized = {
                    id: match.params?.id,
                    periodType: data.periodType,
                    ...(data.periodType ? { period: Number(data.period) } : {}),
                    typeId: data.typeId,
                    date: dateTimeToView(data.date, "YYYY-MM-DD"),
                    value: Number(data.value),
                    comment: data.comment,
                    fileIds: data.fileIds?.map((file) => file.id),
                    ...resourceByName[data.resource],
                };

                return source
                    .apply(serialized)
                    .then((res) =>
                        res ? this.update(mergeParams) : this.setState({ isLoading: false, isValid: false }),
                    );
            }
            this.setState({ isValid: false });
        }
    };

    renderResource = () => {
        const { config } = this.props;
        const { resource } = this.state.data;

        if (!resource) {
            return null;
        }

        const configByResource = {
            [resourceEnum.CAR]: config.carId,
            [resourceEnum.TRAILER]: config.trailerId,
            [resourceEnum.DRIVER]: config.driverId,
        };

        return this.renderSelect({ ...configByResource[resource], validators: [requiredField], required: true });
    };

    renderFiles = () => (
        <FilesField
            isMultiple
            uploadFile={this.props.source.uploadFile}
            modal={this.props.addModal}
            files={this.state.data.fileIds}
            onChange={(files) => this.setValue({ name: "fileIds", value: files })}
        />
    );

    renderBody = () => {
        const { data } = this.state;

        return (
            <>
                {this.renderSelect(config.resource)}
                {this.renderResource()}
                {this.renderSelect(config.periodType)}
                {data.periodType && this.renderField({ ...config.period, validators: [requiredField], required: true })}
                {this.renderSelect(config.typeId)}
                {this.renderDateField(config.date)}
                {this.renderField(config.value)}
                {this.renderField(config.comment)}
                {this.renderFiles()}
                {this.renderButton()}
            </>
        );
    };
}

const ConfiguredShow = (props) => <ShowExpense {...props} config={config} initialState={initialState} />;

export default viewContainer(ConfiguredShow, "region-groups");
